// extracted by mini-css-extract-plugin
module.exports = {"link":"SalesTransactions_link__2nqrw"};